import { Component, OnInit, QueryList, ContentChildren, AfterContentInit } from '@angular/core';
import { TemplateDirective } from '../../directives/template.directive';

@Component({
  selector: 'lib-toolbar-grid',
  templateUrl: './toolbar-grid.component.html',
  styleUrls: ['./toolbar-grid.component.scss']
})
export class ToolbarGridComponent implements OnInit, AfterContentInit {

  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;
  leftSideTemplate: any;
  rightSideTemplate: any;

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {

    const leftSide = this.templates.find(temp => temp.getType() == 'left');
    const rightSide = this.templates.find(temp => temp.getType() == 'right');

    if (leftSide) {
      this.leftSideTemplate = leftSide.template;
    }

    if (rightSide) {
      this.rightSideTemplate = rightSide.template;
    }

  }
}
